import {GET_ALL_CART} from "../actionTypes";

const allCart = (state = [], action) => {
    switch (action.type) {
        case GET_ALL_CART:
            return action.payload;

        default:
            return state;
    }
};

export default allCart;
